<template>
  <div :style="{height}" class="Wh-list">
    <van-pull-refresh v-model="refreshing" :disabled="disabledRefresh" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length ? '已经到底了' : ''"
        @load="onLoad"
      >
        <slot :list="list" :res="res">
          <van-cell v-for="(item, index) in list" :key="index" :title="index" />
        </slot>
        <template v-if="!list.length && !loading">
          <slot name="empty">
            <van-empty description="暂无数据" />
          </slot>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import instance from '@/api/config'

export default {
  name: 'WhMobileList',
  props: {
    // 请求url地址
    dataSrc: {
      type: String,
      required: true
    },
    // 页面page默认参数设置
    page: {
      type: Object,
      default() {
        return {
          page: 1,
          pageSize: 10
        }
      }
    },
    extraParams: {
      type: Object,
      default() {
        return {}
      }
    },
    // 禁用刷新
    disabledRefresh: {
      type: Boolean,
      default: false
    },
    // 是否启用list自动加载
    disabledListLoad: {
      type: Boolean,
      default: false
    },
    // 组件高度
    height: {
      type: String,
      default: '100%'
    },
    getListData: {
      type: Function,
      default: (res) => {
        return res.data.list || []
      }
    },
    getTotalPageFromResponse: {
      type: Function,
      default: (res) => {
        if (res.data && res.data.total) {
          return res.data.total
        }
        return 0
      }
    }
  },
  data() {
    return {
      res: undefined,
      list: [],
      total: 0,
      loading: false,
      finished: this.disabledListLoad,
      refreshing: false,
      pageParams: {
        page: 1,
        pageSize: 10,
        ...this.page
      }
    }
  },
  watch: {
    dataSrc: {
      handler(val, oldVal) {
        this.onRefresh()
      },
      immediate: true
    },
    extraParams: {
      handler(val, oldVal) {
        this.onRefresh()
      },
      deep: true
    }
  },
  methods: {
    onLoad() {
      this.pageParams.page++
      this.getList()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.pageParams = {
        page: 1,
        pageSize: 10,
        ...this.page
      }
      this.refreshing = true
      // 重新加载数据
      this.getList()
    },
    getList() {
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      instance.get(this.dataSrc, {
        params: {
          ...this.pageParams,
          ...this.extraParams
        }
      }).then((res) => {
        if (this.refreshing) {
          this.list = []
        }
        // 完整的response信息
        this.res = res
        // pageInfo 用于解析种养品种数据
        const list = this.getListData(res)
        if (list) {
          this.list = this.list.concat(list)
        }
        this.total = this.getTotalPageFromResponse(res)
        this.refreshing = false
        this.loading = false
        if (this.list.length >= this.total) {
          this.finished = true
        }
      }).catch(() => {
        this.refreshing = false
        this.loading = false
        this.finished = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.Wh-list{
  overflow-y: auto;
}
</style>
